// extracted by mini-css-extract-plugin
export default {"noOrg":"noOrg-UQhNa","text":"text-xH5df","title":"title-TmWnG","subtitle":"subtitle-z7bsy","link":"link-gVaIC"};